import factory from '../requestFactory';

export default ({uid}) => {
    return factory()
        .get(`/patient/diagnostic-files/${uid}/get-file`)
};
